<template>
  <div
    class="content"
    style="padding-top: 50px; font-size: 20px; text-align: center"
  >
    <h3>Το email επαληθεύτηκε επιτυχώς!</h3>
    <h4>
      Μπορείτε να εισέλθετε στην εφαρμογή χρησιμοποιώντας το email και τον
      κωδικό πρόσβασης που δηλώσατε.
    </h4>
    <div>
      <button
        style="display: block; margin: 0 auto; position: inherit; float: none"
        type="button"
        class="generic-button"
        @click="login"
      >
        <span class="button__text">ΕΙΣΟΔΟΣ</span>
      </button>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import router from "../../router";

export default {
  props: ["a", "b"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    login() {
      router.replace("/login");
    },
  },

  async mounted() {
    const res = await mainService.get(
      `/users/ChangeEmail?uid=${this.a}&em=${this.b}`
    );
    if (res.data == true) {
      router.push("/user");
    }
  },
};
</script>